// UTF-8 encoding of a passphrase string into a fresh Uint8Array. The
// caller is responsible for zeroizing the returned buffer once the
// worker has consumed it — that's what `zeroize` is for.
//
// Note: this does NOT (and cannot) scrub the original JS string. V8
// internalises strings and we have no API to touch those bytes.
// Minimize the time passphrase strings live in JS by calling this
// encoder on the same event-loop tick the user hits "submit".

const encoder = new TextEncoder();

/** Encode `s` to a fresh UTF-8 Uint8Array. */
export function toPassphraseBytes(s: string): Uint8Array {
  return encoder.encode(s);
}

/** Overwrite the buffer with zeros in place. */
export function zeroize(bytes: Uint8Array): void {
  bytes.fill(0);
}
